import { Link, useNavigate } from 'react-router-dom';
import { Avatar, Menu } from '@mantine/core';
import { IconHome, IconLogout, IconRoute, IconShieldCheck, IconUserCircle } from '@tabler/icons-react';
import { RIDES_ROLES } from '@actschurch/ccms-sdk';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { useCopy, photoRules } from '@/lib/settings';
import { useMyPhoto } from '@/lib/photo';
import { useMeSummary } from '@/lib/me';
import { AppearanceMenuItems } from './ThemeMenu';

/** Signed-in header: the member's photo or initials (48 px target) opening the account menu. */
export function AccountMenu() {
  const navigate = useNavigate();
  const { logout, getUserInitials, getUserDisplayName, hasAnyRole } = useEnrichedAuth();
  const { settings } = useCopy();
  const myPhoto = useMyPhoto();
  const { data: summary } = useMeSummary();
  const avatarSrc = photoRules(settings).enabled ? myPhoto.url : null;
  const isSecurity = settings.securityViewEnabled && hasAnyRole([RIDES_ROLES.RidesSecurity, RIDES_ROLES.RidesAdmin, RIDES_ROLES.Admin]);
  const name = getUserDisplayName();

  return (
    <Menu position="bottom-end" withinPortal width={250} offset={4}>
      <Menu.Target>
        <button type="button" className="rides-iconbtn" aria-label="Account menu">
          <Avatar
            component="span"
            size={36}
            radius="xl"
            color="brand"
            variant="light"
            src={avatarSrc}
            alt=""
            imageProps={{ referrerPolicy: 'no-referrer', draggable: false }}
            className="rides-avatar-ring"
          >
            {getUserInitials()}
          </Avatar>
        </button>
      </Menu.Target>
      <Menu.Dropdown>
        {name && <Menu.Label style={{ fontSize: 15, color: 'var(--rides-ink)', fontWeight: 700 }}>{name}</Menu.Label>}
        <Menu.Item leftSection={<IconHome size={18} />} component={Link} to="/home">Home</Menu.Item>
        {summary?.hasDriverProfile && <Menu.Item leftSection={<IconRoute size={18} />} component={Link} to="/drive/listings">My lifts</Menu.Item>}
        {isSecurity && <Menu.Item leftSection={<IconShieldCheck size={18} />} component={Link} to="/security">Campus security</Menu.Item>}
        <Menu.Item leftSection={<IconUserCircle size={18} />} component={Link} to="/account">Account</Menu.Item>
        <Menu.Divider />
        <AppearanceMenuItems />
        <Menu.Divider />
        <Menu.Item leftSection={<IconLogout size={18} />} onClick={async () => { await logout(); navigate('/'); }}>Sign out</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
